import { createContext, PropsWithChildren, useContext, useMemo } from "react";
import { TagManyQuery } from "gql/generated";
import { ApolloError } from "@apollo/client";

export type BuildListContextValues = {
  tags: TagManyQuery["tagMany"];
  tagsLoading: boolean;
  tagsError: ApolloError | undefined;
} & PropsWithChildren;

const context = createContext<BuildListContextValues | null>(null);

export const BuildListContextProvider = ({
  children,
  tags,
  tagsError,
  tagsLoading
}: BuildListContextValues) => {
  const contextValue: BuildListContextValues = useMemo(
    () => ({ tags, tagsError, tagsLoading }),
    [tags, tagsError, tagsLoading],
  );

  return <context.Provider value={contextValue}>{children}</context.Provider>;
};

export const useBuildListContext = () => {
  const buildListContext = useContext(context);

  if (!buildListContext) {
    throw new Error(
      "useBuildListContext must be used within a BuildListContextProvider",
    );
  }

  return buildListContext;
};
